module.exports = __webpack_public_path__ + "media/images/header-bg-b27e6e04988e0131d7ef3a1307cddb5b.png";